import { type Deviation, Severity } from 'API';

export const setSeverity = (deviations: Deviation[] | undefined): Severity => {
    if (deviations?.find(deviation => deviation.severity === Severity.FATAL)) {
        return Severity.FATAL;
    }

    if (deviations?.find(deviation => deviation.severity === Severity.ERROR)) {
        return Severity.ERROR;
    }

    if (deviations?.find(deviation => deviation.severity === Severity.WARNING)) {
        return Severity.WARNING;
    }

    return Severity.UNKNOWN;
};
